import { render, staticRenderFns } from "./CaseAdd.vue?vue&type=template&id=453cd35a&"
import script from "./CaseAdd.vue?vue&type=script&lang=js&"
export * from "./CaseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports